<template>
    <el-dialog title="Bloquear/Desbloquear masivamente"
        :visible="showDialog"
        @close="close"
        @open="initForm"
        width="35%"
    >
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label class="control-label">
                        Acción a realizar
                    </label>
                    <el-select v-model="form.optionSelected" placeholder="Seleccione una opción">
                        <el-option v-for="option in options"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id"
                        ></el-option>
                    </el-select>
                </div>
            </div>
            <div class="col-12 text-center mt-2">
                <el-upload
                    ref="upload"
                    action="/systems/lock_or_unlock"
                    accept=".xlsx, .xls"
                    :data="form"
                    
                    :headers="uploadHeaders"
                    :multiple="false"
                    :limit="1"
                    :on-success="handleSuccess"
                    :on-progress="handleProgress"
                    :before-upload="beforeUpload"
                    :auto-upload="false"
                    class="upload-demo"
                >
                    <el-button type="primary"
                        size="small"
                    >
                        Seleccionar un archivo (xlsx)
                    </el-button>
                </el-upload>
                <br>
                <small>
                    <a class="text-dark mr-auto"
                        href="/formats/lock_or_unlock_systems.xlsx"
                        target="_new"
                    >
                        <span class="mr-2">Descargar formato de ejemplo</span>
                        <i class="fa fa-download"></i>
                    </a>
                </small>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                @click.prevent="close"
            >
                Cancelar
            </el-button>
            <el-button type="primary"
                @click.prevent="submit"
                :loading="loading_submit"
            >
                Procesar
            </el-button>
        </span>
    </el-dialog>
</template>

<script>

    export default {
        name: "LockOrUnlock",
        props: ['showDialog'],
        data() {
            return {
                optionSelected: null,
                options: [
                    {
                        id: 'lock',
                        name: 'Bloquear'
                    },
                    {
                        id: 'unlock',
                        name: 'Desbloquear'
                    }
                ],
                form: {},
                loading: null,
                loading_submit: false,
                uploadHeaders: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            }
        },
        methods: {
            close() {
                this.$refs.upload.clearFiles()
                this.$emit('update:showDialog', false)
            },
            initForm() {
                this.form = {
                    optionSelected: null
                }
            },
            handleProgress(event, file, fileList) {
                this.loading = this.$loading({
                    lock: true,
                    text: 'Se está procesando la información, por favor espere.',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },
            handleSuccess(response, files, fileList) {
                
                if (response.success) {
                    this.$message.success(response.message)
                    this.$eventHub.$emit('reloadData')
                    this.close()
                    if (response.data.modified && response.data.modified > 0) {
                        setTimeout(() => {
                            this.$message.success(`Se han actualizado ${response.data.modified} registros`)
                        }, 2000)
                    }
                } else {
                    this.$message.error(response.message)
                }
                this.loading.close()
                this.$refs.upload.clearFiles()
            },

            async submit() {
                if (!this.form.optionSelected) {
                    this.$message.warning('Seleccione una acción a realizar')
                    return
                }
                if (this.$refs.upload.uploadFiles.length === 0) {
                    this.$message.warning('Seleccione un archivo')
                    return
                }
                const { data } = await this.$http.get(`/systems/verify_permission_lock_or_unlock`)
                
                if (data.lock_unlock_clients_system) {
                    this.loading_submit = true
                    await this.$refs.upload.submit()
                    this.loading_submit = false 
                } else {
                    this.$message.error('No tienes permiso para realizar esta acción')
                }
            },
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/clients/partials/LockOrUnlock.vue